import { render, staticRenderFns } from "./airlinedetails.vue?vue&type=template&id=0d0ca24d&scoped=true&"
import script from "./airlinedetails.vue?vue&type=script&lang=js&"
export * from "./airlinedetails.vue?vue&type=script&lang=js&"
import style0 from "./airlinedetails.vue?vue&type=style&index=0&id=0d0ca24d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0ca24d",
  null
  
)

export default component.exports